import { styled } from "@mui/system";

export const StyledRichTextContainer = styled("div")(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: "12px",
  backgroundColor: theme.palette.background.default,
  overflow: "hidden",
  "& .ql-toolbar": {
    backgroundColor: theme.palette.grey[50],
    boxShadow: `0px 4px 8px ${theme.palette.grey[200]}`,
    border: "none",
    padding: theme.spacing(1),
  },
  "& .ql-container": {
    backgroundColor: theme.palette.common.white,
    border: "none",
    minHeight: "200px",
    fontSize: "14px",
  },
  "& .ql-editor": {
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
    minHeight: "200px",
  },
  "& .ql-toolbar .ql-stroke": {
    stroke: theme.palette.grey[800],
  },
  "& .ql-toolbar .ql-fill": {
    fill: theme.palette.grey[800],
  },
  "& .ql-toolbar .ql-picker": {
    color: theme.palette.grey[800],
  },
  "& .ql-toolbar .ql-picker-options": {
    backgroundColor: theme.palette.common.white,
  },
  "& .ql-toolbar .ql-active": {
    color: theme.palette.text.primary,
  },
}));
